window.addEventListener("message", function (event) {
    if ($(window).width() >= 930) {
        try {

            var obj = JSON.parse(event.data);
            //console.log(obj);

            try {

                if (obj.messenger == "ad") {

                    console.log(obj);

                    var adType = (obj.type).toLowerCase();
                    console.log("adType = " + adType);

                    $(function () {

                        if (adType == "wallpaper") {

                            var mainheight = $('.main-page').height();

                            $('#wallpaper-knockout').css({ "height": mainheight });
                            $('#div-gpt-ad-Wallpaper').css({ "height": mainheight });
                            $('#div-gpt-ad-Wallpaper iframe').css({ "height": mainheight });

                            window.onload = function () {

                                setTimeout(function () {

                                    var topbar = document.getElementsByClassName('topbar');
                                    var topbarOffset = topbar[0].offsetTop;

                                    var navbar = document.getElementsByClassName('navbar-wrap');
                                    var navbarOffset = navbar[0].offsetTop;

                                    var advert = document.getElementsByClassName('advert-takeover');
                                    var advertOffset = navbar[0].offsetTop;

                                    var newheight = mainheight + navbarOffset + advertOffset;

                                    $('#div-gpt-ad-Wallpaper').css({ "height": newheight });
                                    $('#div-gpt-ad-Wallpaper iframe').css({ "height": newheight });

                                }, 5000);

                            }

                            var head = document.head;
                            var link = document.createElement("link");

                            link.type = "text/css";
                            link.rel = "stylesheet";
                            link.href = "/dist/css/nmg-wallpaper.css?20190313";

                            head.appendChild(link);

                        }

                    });

                }

                obj = null;
                //console.log(obj);

            }
            catch (err) {
                //console.log(err.toString);
            }
        }
        catch (err) {
            //console.log("Cannot parse object as JSON");
        }
    }

});
